module.exports = __webpack_public_path__ + "img/cartoonHead0-2.d06728e2.png";